import { useCallback } from 'react';

/**
 * Hook para scroll suave a una sección por ID.
 * Centraliza la lógica duplicada en Header, Hero, Footer y Services.
 * Actualiza el hash de la URL para navegación compartible.
 */
export function useScrollToSection() {
  const scrollToSection = useCallback((id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Update URL hash for shareable links
      if (window.location.hash !== `#${id}`) {
        history.pushState(null, '', `#${id}`);
      }
    }
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (window.location.hash) {
      history.pushState(null, '', window.location.pathname);
    }
  }, []);

  return { scrollToSection, scrollToTop };
}
